<template>
  <div class="most-active-content full-height">
    <div class="box flex column">
      <div class="box grow flex">
        <span class="box self-flex-end pre-wrap body1">{{ title }}</span>
      </div>
      <div class="box subtitle2">Past 24 hours</div>
    </div>
    <top-ten-card
      v-loading="loading"
      :entries="mostActiveEntries"
      :col-headers="colHeaders"
      :starting-page-num="startPageNo"
      :page-size="10"
      @top-ten-click="emitTopTenSelection"
      ref="toptenCard"
    ></top-ten-card>
  </div>
</template>

<script>
import TopTenCard from '@/components/card/TopTenCard.vue'

import { MOST_ACTIVE_LIST_REQ } from '@/store/modules/statistics/most-active.type'

export default {
  name: 'MostActiveCard',
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    name: {
      type: String,
      default: () => {
        return ''
      }
    },
    agentId: {
      type: String,
      default: () => {
        return ''
      }
    },
    osType: {
      type: String,
      default: () => {
        return 'windows'
      }
    },
    colHeaders: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      mostActiveEntries: [],
      startPageNo: 1
    }
  },
  created () {
    // always load tab details
    this.fetchMostActive()
  },
  methods: {
    fetchMostActive () {
      this.loading = true
      this.$store
        .dispatch(MOST_ACTIVE_LIST_REQ, {
          eventType: this.name,
          agentId: this.agentId,
          osType: this.osType
        })
        .then(
          stats => {
            this.loading = false
            this.mostActiveEntries = stats
          },
          errMsg => {
            this.loading = false
            console.log(errMsg.toString())
          }
        )
    },
    emitTopTenSelection (row) {
      this.$emit('row-click', { name: this.name, row: row })
    }
  },
  components: {
    TopTenCard
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.most-active-content {
  border: 1px solid var(--border-color);
  padding: 8px;
}

>>> .top-ten {
  height: calc(100% - 75px) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/MostActiveCard.vue